const sanitizeBackendHtml = (html) => {
    let sanitizedHtml = html || '';

    // Remove \u200b (zero-width space) characters from the content, as CKEditor likes to add them
    sanitizedHtml = sanitizedHtml.replace(/\u200b/g, '');

    return sanitizedHtml;
};

export default sanitizeBackendHtml;
